/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderRequestItem {
  brandEquity?: number;
  category?: string;
  costPrice?: number;
  defaultImageURL?: string;
  discount?: number;
  externalId?: number;
  inStockAcquisition?: number;
  internalEAN?: string;
  invoicePrice?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  salePrice?: number;
  shippingOrderId?: number;
  shippingOrderItemId?: number;
  shippingOrderRequestId?: number;
  shippingOrderStatus?: number;
  weight?: number;
}
